import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { push as pushAction } from 'redux-first-history';

import ContentCrateLoading from 'shared/app/components/content-crate-loading';
import { getFraudReputation } from 'shared/app/utils/iovation';
import { queryParamsSelector } from 'shared/app/state/selectors/routes';

import { signInWithSsoToken as signInWithSsoTokenAction } from '../../state/action-creators';

const SingleSignOn = ({ push, returnUrl = '/', signInWithSsoToken }) => {
  useEffect(() => {
    getFraudReputation()
      .then((reputation) => signInWithSsoToken({ reputation }))
      .then(({ returnUrl: redirectUrl }) =>
        window.location.replace(redirectUrl)
      )
      .catch(() => {
        push(`/account/signin?returnUrl=${encodeURIComponent(returnUrl)}`);
      });
  }, []);

  return (
    <div className="py6 height-100">
      <ContentCrateLoading />
    </div>
  );
};

const select = (state) => ({
  returnUrl: queryParamsSelector(state)?.returnUrl,
});

const actions = {
  push: pushAction,
  signInWithSsoToken: signInWithSsoTokenAction,
};

export default connect(select, actions)(SingleSignOn);
